import {
	IAuthorization,
	IPlatformAuthorizer,
} from '@studyportals/bodies-editor-integration';
import { PlatformIntegration } from '@/platform/PlatformIntegration';

export class PlatformAuthorizerDecoratorUiLoader implements IPlatformAuthorizer {
	private readonly target: IPlatformAuthorizer;

	public constructor(target: IPlatformAuthorizer) {
		this.target = target;
	}

	public async authorizeBodyQuery(): Promise<IAuthorization> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.authorizeBodyQuery();
		} finally {
			loader.dispose();
		}
	}

	public async authorizeBodyCreate(): Promise<IAuthorization> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.authorizeBodyCreate();
		} finally {
			loader.dispose();
		}
	}

	public async authorizeBodyUpdate(idOfBody: string): Promise<IAuthorization> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.authorizeBodyUpdate(idOfBody);
		} finally {
			loader.dispose();
		}
	}
}
